import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

import Payouts from "components/Panel/Admin/Payouts";
import { useDispatch, useSelector } from "react-redux";
import { getPayouts } from "redux/admin/payout/payoutSlice";
import Pagination from "components/Pagination";

const PayoutsContainer = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.adminPayouts.payouts);
  const { total, pages, page, per_page } = useSelector(
    (state) => state.adminPayouts.payouts
  );

  // Filter states
  const [search, setSearch] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [perPageSelection, setPerPageSelection] = useState(30);
  const [statusFilter, setStatusFilter] = useState("");
  
  // Debounced search
  const [debouncedSearch] = useDebounce(search, 500);

  // Load initial data and update when filters change
  useEffect(() => {
    const params = {
      page: 1,
      per_page: perPageSelection,
    };

    if (debouncedSearch) params.holder_name = debouncedSearch;
    if (minAmount) params.amount_min = parseFloat(minAmount);
    if (maxAmount) params.amount_max = parseFloat(maxAmount);
    if (statusFilter) params.status = statusFilter;

    dispatch(getPayouts(params));
  }, [dispatch, debouncedSearch, minAmount, maxAmount, perPageSelection, statusFilter]);

  const handlePageChange = (newPage) => {
    const params = {
      page: newPage,
      per_page: perPageSelection,
    };

    if (debouncedSearch) params.holder_name = debouncedSearch;
    if (minAmount) params.amount_min = parseFloat(minAmount);
    if (maxAmount) params.amount_max = parseFloat(maxAmount);
    if (statusFilter) params.status = statusFilter;

    dispatch(getPayouts(params));
  };

  return (
    <div className="bg-black min-h-screen">
      <div className="p-4 flex justify-between">
        <h2 className="text-xl font-semibold text-white-100">
          Para Çekme Talepleri
        </h2>
      </div>

      {/* Filter Controls */}
      <div className="px-4 pb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          {/* Search Box */}
          <div>
            <label className="block text-sm text-white-200 mb-1">
              Ad Soyad Ara
            </label>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              className="w-full border border-gray-500 rounded-lg p-2 bg-gray-800 text-white-100"
              placeholder="Hesap sahibi adı..."
            />
          </div>

          {/* Min Amount */}
          <div>
            <label className="block text-sm text-white-200 mb-1">
              Min Tutar
            </label>
            <input
              value={minAmount}
              onChange={(e) => setMinAmount(e.target.value)}
              type="number"
              step="0.01"
              className="w-full border border-gray-500 rounded-lg p-2 bg-gray-800 text-white-100"
              placeholder="0.00"
            />
          </div>

          {/* Max Amount */}
          <div>
            <label className="block text-sm text-white-200 mb-1">
              Max Tutar
            </label>
            <input
              value={maxAmount}
              onChange={(e) => setMaxAmount(e.target.value)}
              type="number"
              step="0.01"
              className="w-full border border-gray-500 rounded-lg p-2 bg-gray-800 text-white-100"
              placeholder="0.00"
            />
          </div>

          {/* Status Filter */}
          <div>
            <label className="block text-sm text-white-200 mb-1">
              Durum
            </label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="w-full border border-gray-500 rounded-lg p-2 bg-gray-800 text-white-100"
            >
              <option value="">Tümü</option>
              <option value="pending_transfer">Aktarım Bekliyor</option>
              <option value="completed">Aktarım Yapıldı</option>
              <option value="failed">Aktarım Reddedildi</option>
            </select>
          </div>
        </div>

        {/* Per Page Selection */}
        <div className="flex items-center gap-4">
          <label className="text-sm text-white-200">
            Sayfa başına:
          </label>
          <select
            value={perPageSelection}
            onChange={(e) => setPerPageSelection(parseInt(e.target.value))}
            className="border border-gray-500 rounded-lg p-2 bg-gray-800 text-white-100"
          >
            <option value={15}>15</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={300}>300</option>
          </select>
        </div>
      </div>

      <Payouts data={data} />
      <Pagination
        currentPage={page}
        totalPages={pages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PayoutsContainer;
